module.exports = __webpack_public_path__ + "img/stra3.36b8d281.png";